module.exports = __webpack_public_path__ + "img/companyImg4.26cff49c.jpg";